import { ReportingPeriodResponse } from "../../app/features/vehicles/domain/mro-manual-model";

export const ReportingPeriodResponseMock: ReportingPeriodResponse = {
    coveredPeriodEndDate: "2025-06-30T21:59:59",
    coveredPeriodStartDate: "2025-03-31T22:00:00",
    createdAt: "2025-06-02T11:01:35",
    graceWindowEndDate: "2025-09-30T21:59:59",
    graceWindowStartDate: "2025-06-30T22:00:00",
    id: "b79d13aa-9a6d-4e0a-a963-00bdd67315d1",
    name: "Q2-2025",
    regularWindowEndDate: "2025-06-30T21:59:59",
    regularWindowStartDate: "2025-06-15T22:00:00",
    status: "OPENED",
    updatedAt: null
};
